/**
 * Phase 5f ÔÇö Kunden lesen: Domain-Aggregat-Index + merged Blob.
 */

import { listAggregateCustomers } from '../infrastructure/storage/domainAggregateStore';
import { listEntityCustomers } from '../infrastructure/storage/entityAggregateStore';
import { readBlobFirstWithAggregateFallback } from './canonicalEntityRead';
import { readSyncWithBlobPriority, readArrayFieldFromMergedBlob } from './businessStateSync';

/** @type {Map<string, object[]>} */
const customersReadCache = new Map();

export function readCustomersFromMergedBlob(businessId) {
  return readArrayFieldFromMergedBlob(businessId, 'customers', getCachedCustomersRead);
}

/**
 * @param {string} businessId
 * @returns {Promise<object[]>}
 */
export async function readCustomersFromBestSource(businessId) {
  return readBlobFirstWithAggregateFallback(
    businessId,
    readCustomersFromMergedBlob,
    listAggregateCustomers,
    listEntityCustomers,
    ['id', 'customerId']
  );
}

export async function refreshCustomersReadCache(businessId, preloaded) {
  const customers =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readCustomersFromBestSource(businessId);
  if (businessId) {
    customersReadCache.set(String(businessId), customers);
  }
  return customers;
}

export function getCachedCustomersRead(businessId) {
  if (!businessId) return null;
  return customersReadCache.get(String(businessId)) ?? null;
}

export function clearCustomersReadCache(businessId) {
  if (businessId) {
    customersReadCache.delete(String(businessId));
  } else {
    customersReadCache.clear();
  }
}

export function seedCustomersReadCache(businessId, customers) {
  if (!businessId || customers === undefined) return;
  customersReadCache.set(String(businessId), Array.isArray(customers) ? customers : []);
}

/** Synchroner Lesepfad (Cache Ôê¬ Blob, Blob-Priorit├ñt). */
export function readCustomersSyncForBusiness(businessId) {
  return readSyncWithBlobPriority(
    businessId,
    readCustomersFromMergedBlob,
    getCachedCustomersRead,
    'id',
    'customerId'
  );
}
